module.exports = __webpack_public_path__ + "components/icon/static/moonset-6367b95257edd5aba010e960170d720d.svg";